var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#4066FF", fillRule: "evenodd", d: "M21.055 15l-4.553-4.556V13.5h-5.946c-.53 0-1.03.108-1.5.277V7.554h3.055L7.555 3 3 7.554h3.056V20.25c0 .414.335.75.75.75h1.5a.75.75 0 0 0 .75-.75V18c0-.83.67-1.5 1.5-1.5h5.946v3.055L21.055 15z" })
  );
});